const actions = {
  // BITAQATY BALANCE ACTIONS
  GET_BITAQATY_BALANCE_BEGIN: 'GET_BITAQATY_BALANCE_BEGIN',
  GET_BITAQATY_BALANCE_SUCCESS: 'GET_BITAQATY_BALANCE_SUCCESS',
  GET_BITAQATY_BALANCE_ERR: 'GET_BITAQATY_BALANCE_ERR',
  // DALEEL STORE BALANCE ACTIONS
  GET_DALEEL_STORE_BALANCE_BEGIN: 'GET_DALEEL_STORE_BALANCE_BEGIN',
  GET_DALEEL_STORE_BALANCE_SUCCESS: 'GET_DALEEL_STORE_BALANCE_SUCCESS',
  GET_DALEEL_STORE_BALANCE_ERR: 'GET_DALEEL_STORE_BALANCE_ERR',
  // BITAQATY BALANCE ACTION
  GET_QWIK_BALANCE_BEGIN: 'GET_QWIK_BALANCE_BEGIN',
  GET_QWIK_BALANCE_SUCCESS: 'GET_QWIK_BALANCE_SUCCESS',
  GET_QWIK_BALANCE_ERR: 'GET_QWIK_BALANCE_ERR',
  // PAYNET BALANCE ACTIONS
  GET_PAYNET_BALANCE_BEGIN: 'GET_PAYNET_BALANCE_BEGIN',
  GET_PAYNET_BALANCE_SUCCESS: 'GET_PAYNET_BALANCE_SUCCESS',
  GET_PAYNET_BALANCE_ERR: 'GET_PAYNET_BALANCE_ERR',

  getBitaqatyBalanceBegin: () => {
    return {
      type: actions.GET_BITAQATY_BALANCE_BEGIN,
    };
  },

  getBitaqatyBalanceSuccess: (data) => {
    return {
      type: actions.GET_BITAQATY_BALANCE_SUCCESS,
      data,
    };
  },

  getBitaqatyBalanceErr: (err) => {
    return {
      type: actions.GET_BITAQATY_BALANCE_ERR,
      err,
    };
  },

  getQwikBalanceBegin: () => {
    return {
      type: actions.GET_QWIK_BALANCE_BEGIN,
    };
  },

  getQwikBalanceSuccess: (data) => {
    return {
      type: actions.GET_QWIK_BALANCE_SUCCESS,
      data,
    };
  },

  getQwikBalanceErr: (err) => {
    return {
      type: actions.GET_QWIK_BALANCE_ERR,
      err,
    };
  },
  getDaleelStoreBalanceBegin: () => {
    return {
      type: actions.GET_DALEEL_STORE_BALANCE_BEGIN,
    };
  },

  getDaleelStoreBalanceSuccess: (data) => {
    return {
      type: actions.GET_DALEEL_STORE_BALANCE_SUCCESS,
      data,
    };
  },
  getDaleelStoreBalanceErr: (err) => {
    return {
      type: actions.GET_DALEEL_STORE_BALANCE_ERR,
      err,
    };
  },
  getPaynetBalanceBegin: () => {
    return {
      type: actions.GET_PAYNET_BALANCE_BEGIN,
    };
  },

  getPaynetBalanceSuccess: (data) => {
    return {
      type: actions.GET_PAYNET_BALANCE_SUCCESS,
      data,
    };
  },

  getPaynetBalanceErr: (err) => {
    return {
      type: actions.GET_PAYNET_BALANCE_ERR,
      err,
    };
  },
};

export default actions;
